import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import Title from "./Title";
import { projects } from "../../constants/projects";
import List, { Item } from "./List";
import { globalStyles } from "../../views/Resume";

const styles = StyleSheet.create({
  projectTitle: {
    fontSize: 6,
    fontFamily: "Lato Bold",
    marginBottom: 2,
  },
  details: {
    fontSize: 6,
    fontFamily: "Lato",
  },
  summary: {
    fontSize: 6,
    fontFamily: "Lato",
    marginBottom: 2,
  },
});

const SummaryList = ({ summary }) => (
  <List>
    {summary.map((item) => (
      <Item key={item}>
        <Text style={styles.summary}>{item}</Text>
      </Item>
    ))}
  </List>
);

const KeyProjects = () => {
  const pathname = window.location.pathname;

  return (
    <View style={globalStyles.container}>
      <View>
        <Title>Key Projects</Title>
      </View>
      {projects
        .slice(0, 3)
        .map(({ name, summary, frontendSummary, backendSummary }) => (
          <View key={name}>
            <Text style={styles.projectTitle}>{name}</Text>
            {pathname.includes("frontend") ? (
              <SummaryList summary={frontendSummary} />
            ) : pathname.includes("backend") ? (
              <SummaryList summary={backendSummary} />
            ) : (
              <SummaryList summary={summary} />
            )}
          </View>
        ))}
    </View>
  );
};
export default KeyProjects;
